"use client";

import { useEffect } from "react";
import { initializeToolRegistry } from "@/lib/tools/registry";
import { UserProvider } from "@/lib/user/context";
import { getDb } from "@/lib/db";
import { registerSupabaseProfileHooks } from "@/lib/supabase/syncProfiles";
import { registerSupabaseMessageHooks } from "@/lib/supabase/syncMessages";

export function Providers({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    const init = () => initializeToolRegistry().catch(() => {});
    if (typeof requestIdleCallback !== "undefined") {
      requestIdleCallback(init, { timeout: 2000 });
    } else {
      setTimeout(init, 500);
    }
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;
    try {
      const db = getDb();
      registerSupabaseProfileHooks(db);
      registerSupabaseMessageHooks(db);
    } catch {
      // getDb throws on server
    }
  }, []);

  // Register PWA service worker as early as possible and request persistent storage.
  useEffect(() => {
    if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        if (reg.installing) {
          reg.installing.addEventListener("statechange", (e) => {
            const sw = e.target as ServiceWorker;
            if (sw.state === "activated") {
              console.log("[PWA] Service worker activated");
            }
          });
        }
      })
      .catch(() => {});

    if ("storage" in navigator && "persist" in navigator.storage) {
      navigator.storage.persist().catch(() => {});
    }
  }, []);

  return <UserProvider>{children}</UserProvider>;
}

